export const calculateWorkingHours = (entryTime, exitTime) => {
    if (!entryTime || !exitTime) return null;  // If either is missing, return nothing

    const entry = new Date(entryTime);
    const exit = new Date(exitTime);

    const diffMs = exit - entry;  // Difference in milliseconds

    const hours = Math.floor(diffMs / (1000 * 60 * 60));       // Hours
    const minutes = Math.floor((diffMs / (1000 * 60)) % 60);   // Minutes

    return `${hours}h ${minutes}m`;
};

export const formatDateTime = (dateString) => {
    if (!dateString) return "";
    const date = new Date(dateString.replace(' ', 'T'));
    const day = String(date.getDate()).padStart(2, "0");
    const month = String(date.getMonth() + 1).padStart(2, "0");
    const year = date.getFullYear();
    const hours = String(date.getHours()).padStart(2, "0");
    const minutes = String(date.getMinutes()).padStart(2, "0");
    const seconds = String(date.getSeconds()).padStart(2, "0");

    return `${day}-${month}-${year} ${hours}:${minutes}:${seconds}`;
};

export const formatDateTimetoSave = (dateString) => {
    if (!dateString) return "";
    const date = new Date(dateString.replace(' ', 'T'));
    const day = String(date.getDate()).padStart(2, "0");
    const month = String(date.getMonth() + 1).padStart(2, "0");
    const year = date.getFullYear();
    const hours = String(date.getHours()).padStart(2, "0");
    const minutes = String(date.getMinutes()).padStart(2, "0");
    const seconds = String(date.getSeconds()).padStart(2, "0");

    return `${year}-${month}-${day} ${hours}:${minutes}:${seconds}`;
};

export const formatTime = (dateString) => {
    const date = new Date(dateString);

    const day = String(date.getDate()).padStart(2, "0");
    const month = String(date.getMonth() + 1).padStart(2, "0"); // Month is 0-based
    const year = date.getFullYear();

    const hours = String(date.getHours()).padStart(2, "0");
    const minutes = String(date.getMinutes()).padStart(2, "0");
    const seconds = String(date.getSeconds()).padStart(2, "0");

    return `${hours}:${minutes}:${seconds}`;
};



// for 29-11-2025
export const formatDate = (dateStr) => {
    if (!dateStr) return 'NA';

    // Ensure the value is in ISO format
    const date = new Date(dateStr);
    if (isNaN(date)) return 'NA';

    const day = String(date.getDate()).padStart(2, '0');
    const month = String(date.getMonth() + 1).padStart(2, '0'); // getMonth is 0-based
    const year = date.getFullYear();

    return `${day}-${month}-${year}`;
};

export const formatDateTimeQuiz = (date) => {
    const d = new Date(date);
    const day = String(d.getDate()).padStart(2, '0');
    const month = String(d.getMonth() + 1).padStart(2, '0'); // Months are 0-based
    const year = d.getFullYear();
    const time = d.toLocaleTimeString(); // You can customize time format if needed

    return `${day}/${month}/${year}, ${time}`;
}

// for 2025-12-01 for date input tags
export const formatDateForInput = (isoString) => {
    if (!isoString) return '';
    const date = new Date(isoString);

    // getFullYear(), getMonth() starts from 0, getDate()
    const year = date.getFullYear();
    const month = String(date.getMonth() + 1).padStart(2, '0'); // add leading zero
    const day = String(date.getDate()).padStart(2, '0');

    return `${year}-${month}-${day}`;
};

// ✅ Local date in YYYY-MM-DD (based on laptop/browser timezone)
export const getCurrentDate = () => {
    const now = new Date();
    const year = now.getFullYear();
    const month = String(now.getMonth() + 1).padStart(2, "0");
    const day = String(now.getDate()).padStart(2, "0");
    return `${year}-${month}-${day}`;
};

// ✅ UTC date in YYYY-MM-DD (server alignment)
export const getCurrentUTCDate = () => {
    const now = new Date();
    return now.toISOString().split("T")[0];
};

// Current time in HH:mm format (24-hour clock)
export const getCurrentTime = () => {
    const now = new Date();
    const hours = String(now.getHours()).padStart(2, "0");
    const minutes = String(now.getMinutes()).padStart(2, "0");
    return `${hours}:${minutes}`;
};

export const formatDateTimeByZone = (dateString, timeZone) => {
    if (!dateString) return "";

    return new Date(dateString).toLocaleString("en-GB", {
        timeZone,
        year: "numeric",
        month: "2-digit",
        day: "2-digit",
        hour: "2-digit",
        minute: "2-digit",
        second: "2-digit",
        hour12: false
    });
};

export const getUserTimeZone = () => {
    return Intl.DateTimeFormat().resolvedOptions().timeZone;
};

export const formatDateTimeAuto = (utcString) => {
    if (!utcString) return "";

    const userTimeZone = Intl.DateTimeFormat().resolvedOptions().timeZone;

    return new Date(utcString).toLocaleString("en-GB", {
        timeZone: userTimeZone,
        year: "numeric",
        month: "2-digit",
        day: "2-digit",
        hour: "2-digit",
        minute: "2-digit",
        second: "2-digit",
        hour12: false
    });
};